export const POS_SIZING_RISK_SYNC_REQUIRED_CODE = 'position_sizing_durable_context_unknown_legacy';
export const POS_SIZING_RISK_SYNC_REQUIRED_MESSAGE =
    'Position Sizing needs Sync Draft before risk can be calculated.';

export const isPosSizingRiskSyncRequired = (error) => error?.status === 409 && (
    error?.code === POS_SIZING_RISK_SYNC_REQUIRED_CODE
    || error?.code === 'position_sizing_saved_factor_context_unavailable'
);
